export default __webpack_public_path__ + "locales/ja-JP/Translations.json?hash=f68d5c1089dc86251fdfa03d98dfc3c0";